enum TranslationStatus {
  OPEN = 'open',
  COMPLETED = 'completed',
}

export default TranslationStatus
